import { Injectable } from "@angular/core";
import { ObjectInformation } from "../../shared/contract/ObjectInformation/ObjectInformation";
import { Address } from "../../shared/contract/Address/Address";

@Injectable({
  providedIn: "root"
})
export class ObjectInformationService {
  createNewObject = false;
  showEditObjectInformationButton = false;
  objectInformation: ObjectInformation;

  address: Address;
}
